import { render, staticRenderFns } from "./DatesDialog.vue?vue&type=template&id=f5f5c14a&scoped=true&"
import script from "./DatesDialog.vue?vue&type=script&lang=js&"
export * from "./DatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f5c14a",
  null
  
)

export default component.exports